import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {Autoplay, Navigation,Pagination,Scrollbar, A11y,} from "swiper/modules";

import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";
import 'swiper/css/effect-coverflow';

import humanresource from "../pictures/humanresource.jpg";
import digital from "../pictures/digital.jpg";
import evaluationimg from "../pictures/evaluation_img.jpg";
import brandmanagement from "../pictures/brandmanagement.jpg";
import managementconsult from "../pictures/managementconsult.png";
import marketresearch from "../pictures/marketresearch.png";

const Our_Services = () =>
{
    return(
        <>
          <div className="mobile_slider">
            <Swiper
              modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={30}
              slidesPerView={3}
              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction:false,
              }}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_1">
                    <img src={evaluationimg}/>
                  <h2>Evaluation & Accreditation</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_2">
                    <img src={brandmanagement}/>
                  <h2>Brand Management</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_3">
                    <img src={digital}/>
                  <h2>Digital Marketing</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_4">
                    <img src={humanresource}/>
                  <h2>Human Resources Services</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_5">
                    <img src={managementconsult}/>
                  <h2>Business Management Consultancy</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_6">
                    <img src={marketresearch}/>
                  <h2>Market Research</h2>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          <div className="tab_slider">
            <Swiper
              modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={20}
              slidesPerView={3}
              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction:false,
              }}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_1">
                    <img src={evaluationimg}/>
                  <h2>Evaluation & Accreditation</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_2">
                    <img src={brandmanagement}/>
                  <h2>Brand Management</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_3">
                    <img src={digital}/>
                  <h2>Digital Marketing</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_4">
                    <img src={humanresource}/>
                  <h2>Human Resources Services</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_5">
                    <img src={managementconsult}/>
                  <h2>Business Management Consultancy</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_6">
                    <img src={marketresearch}/>
                  <h2>Market Research</h2>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          <div className="slider">
            <Swiper
              modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={50}
              slidesPerView={4}
              navigation={true}
              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction:false,
              }}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_1">
                    <img src={evaluationimg}/>
                  <h2>Evaluation & Accreditation</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_2">
                    <img src={brandmanagement}/>
                  <h2>Brand Management</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_3">
                    <img src={digital}/>
                  <h2>Digital Marketing</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_4">
                    <img src={humanresource}/>
                  <h2>Human Resources Services</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_5">
                    <img src={managementconsult}/>
                  <h2>Business Management Consultancy</h2>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="In_slider_card_1 our_service_card_6">
                    <img src={marketresearch}/>
                  <h2>Market Research</h2>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </>
    )
}

export default Our_Services;